import { handleActions } from 'redux-actions';

export default handleActions(
	{
		FETCH_FACILITIES_FULFILLED: (state, action) => ({
			...state,
			facilityList: action.payload.facilityList,
			facilityData: action.payload.facilityData,
		}),
	},
	{
		facilityList: [],
		facilityData: {},
	},
);



// WEBPACK FOOTER //
// ./src/reducers/facility.js